const Data = {
  WebsiteTitle: "Portfolio | Artists",
  HeaderTitle: "SooNee's Portfolio",
  FooterText: "© 2025 SooNee's Portfolio. All rights reserved.",
  AboutEmail: "artistsoon@gmail.com",
  AboutContactInfo: "Feel free to reach out at <u>artistsoon@gmail.com</u>.<br></br>",
  AboutEmailSubject: "Subject of the Email",
  AboutButtonText: "Say Hey!",
  
  CatalogueUrl: "https://online.flipbuilder.com/crart1004/sgal/",

  // Articles and Press Coverage
  Articles: [
    {
      title: "Light Beyond Silence — Catalogue Raisonné (2006–2026)",
      description: "Twenty years of SooNee's work in one 72-page catalogue: the “Her” series on hanji with ink, coffee and acrylic, a critique by Pierre Coureux (Président, Amitiés Internationales André Malraux), the artist's statement and full profile. Published 30 September 2026 (ISBN 979-11-221605-0-5). Read the full flipbook online.",
      category: "catalog",
      date: "2026-09-30",
      externalUrl: "https://online.flipbuilder.com/crart1004/sgal/"
    },
    {
      title: "Fondation Taylor Registration: Critical Essay - English Version",
      description: "Official critical essay for SooNee's registration with the prestigious Fondation Taylor in France. This English version contains the comprehensive artistic evaluation required for her lifetime membership application, prepared by AIAM Association under Pierre Coureux's direction.",
      category: "catalog",
      date: "2025-07-11",
      pdfUrl: "Portrait d (Eng).pdf"
    },
    {
      title: "Fondation Taylor : Essai Critique - Version Française",
      description: "Essai critique officiel pour l'enregistrement de SooNee auprès de la prestigieuse Fondation Taylor en France. Cette version française contient l'évaluation artistique complète requise pour sa candidature de membre à vie, préparée par l'Association AIAM sous la direction de Pierre Coureux.",
      category: "catalog",
      date: "2025-07-11",
      pdfUrl: "Portrait d (Fr).pdf"
    },
    {
      title: "Fondation Taylor 등재: 비평문 - 한국어 버전",
      description: "프랑스의 명문 Fondation Taylor 등재를 위한 공식 비평문입니다. 이 한국어 버전은 AIAM 협회에서 Pierre Coureux 회장님의 지도 하에 준비한 종신회원 신청에 필요한 종합적인 예술 평가를 담고 있습니다.",
      category: "catalog",
      date: "2025-07-11",
      pdfUrl: "Portrait d (Kr).pdf"
    },
    {
      title: "이순희 작가, 제140회 앙데팡당에서 대중인기상 수상",
      description: "Press coverage of SooNee receiving the Public Choice Award (대중인기상) at the 140th Salon des Indépendants, held in Paris from February 13-18, 2024. The article highlights her internationally recognized portrait work and her extensive exhibition career at home and abroad.",
      category: "press",
      date: "2024-04-04",
      externalUrl: "https://www.mhns.co.kr/news/articleView.html?idxno=580848"
    },
    {
      title: "이순희 작가, 프랑스 AIAM '2025 Prix d'Excellence' 수상",
      description: "Global Epic (글로벌에픽) reports on SooNee receiving the Prix d'Excellence at the AIAM ceremony during Art Capital 2025 in Paris, recognizing her artistic excellence, consistent creative output, and international influence — her second consecutive honor from the European art world.",
      category: "press",
      date: "2025-04-23",
      externalUrl: "https://m.globalepic.co.kr/view.php?ud=202504231407173936cf2d78c68_29"
    }
  ],
};

export default Data;
